const LayoutManage = () => import('@/views/manage/layout')

const routes = [
  //   {
  //   path: '/organization',
  //   redirect: '/organization/index',
  //   component: LayoutManage,
  //   children: [{
  //     path: 'index',
  //     component: () => import('@/views/manage/organization/index'),
  //     meta: {
  //       title: '工作台',
  //       img: '1.png'
  //     }
  //   }]
  // }, 
  
  {
    path: '/user/info',
    redirect: '/user/info/org',
    component: LayoutManage,
    meta: {
      title: '机构信息维护',
      img: '2.png'
    },
    children: [{
      path: 'org',
      component: () => import('@/views/manage/organization/info/org'),
      meta: {
        title: '机构基本信息'
      }
    }, {
      path: 'label',
      component: () => import('@/views/manage/organization/info/label'),
      meta: {
        title: '能力标签'
      }
    }, {
      path: 'qualification',
      component: () => import('@/views/manage/organization/info/qualification'),
      meta: {
        title: '资质信息'
      }
    }]
  }, {
    path: '/organization/service',
    redirect: '/organization/service/index',
    component: LayoutManage,
    children: [{
      path: 'index',
      component: () => import('@/views/manage/organization/service/index'),
      meta: {
        title: '服务内容管理',
        img: '6.png'
      }
    }]
  },{
    path: '/organization/manage',
    component: LayoutManage,
    alwaysShow: true,
    meta: {
      title: '用户管理',
      img: '4.png'
    },
    children: [{
      path: 'editUpwd',
      component: () => import('@/views/manage/organization/manage/editUpwd'),
      meta: {
        title: '修改密码'
      }
    }]
  }]
export default routes
